import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LabsForm from "../Components/LabsForm";
import api from "../../../utils/axios";

const EditLabs = () => {
  const { id } = useParams();

  const [name, setName] = useState("");
  const [officeNumber, setOfficeNumber] = useState("");
  const [address, setAddress] = useState("");
  const [productsAdded, setProductsAdded] = useState([]); // Productos elegidos para agregar
  const [otherProductsAdded, setOtherProductsAdded] = useState([]); // Productos elegidos para agregar
  const [productTagsAdded, setProductTagsAdded] = useState([]); // Tags elegidos para agregar
  const [otherProductTagsAdded, setOtherProductTagsAdded] = useState([]); // Tags elegidos para agregar

  useEffect(() => {

    (async () => {
      try {
        const response = await api.get(`/laboratory/${id}`);
        const { data } = response;
        // console.log("Tags recibidos:", data.tags);

        setName(data.name);
        setOfficeNumber(data.officeNumber);
        setAddress(data.address);
        setProductsAdded(data.products);
        setOtherProductsAdded(data.otherProducts);
        setProductTagsAdded(data.tags.filter((tag) => tag.isProducts));
        setOtherProductTagsAdded(data.tags.filter((tag) => !tag.isProducts));
      } catch (error) {
        console.error("Error al obtener los datos del laboratorio:", error);
      }
    })();
  }, []);

  return (
    <LabsForm
      type="editLabs"
      id={id}
      name={name}
      officeNumber={officeNumber}
      address={address}
      productsAdded={productsAdded}
      otherProductsAdded={otherProductsAdded}
      productTagsAdded={productTagsAdded}
      otherProductTagsAdded={otherProductTagsAdded}
    />
  );
};

export default EditLabs;
